import { render, staticRenderFns } from "./batchSettings.vue?vue&type=template&id=aeea60a8&scoped=true&"
import script from "./batchSettings.vue?vue&type=script&lang=js&"
export * from "./batchSettings.vue?vue&type=script&lang=js&"
import style0 from "./batchSettings.vue?vue&type=style&index=0&id=aeea60a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea60a8",
  null
  
)

component.options.__file = "batchSettings.vue"
export default component.exports